export const TOTAL_STEPS = 14;

export const STEP_NAMES: Record<number, string> = {
  1: 'Bienvenida (especie + nombre)',
  2: 'Datos básicos (edad + sexo + esterilización)',
  3: 'Raza',
  4: 'Peso y condición corporal',
  5: 'Actividad',
  6: 'Comida actual y apetito',
  7: 'Alergias / intolerancias',
  8: 'Condiciones de salud',
  9: 'Cálculo del plan',
  10: 'Recetas',
  11: 'Tipo de dieta',
  12: 'Cómo empezar',
  13: 'Suplementos',
  14: 'Checkout',
};

/**
 * Slugs cortos por paso para telemetría (step_name en los eventos de analytics).
 * DEBE coincidir en numeración con STEP_NAMES de arriba y con el backend
 * (app/core/funnel_steps.py). Antes useAnalytics tenía su propia copia
 * desincronizada (modo_input/trial_box/suplementos/review ya no existen y el
 * orden estaba desfasado) → telemetría mal etiquetada (auditoría 2026-06-11).
 */
export const STEP_SLUGS: Record<number, string> = {
  1: 'welcome',
  2: 'datos_basicos',
  3: 'raza',
  4: 'peso',
  5: 'actividad',
  6: 'comida',
  7: 'alergias',
  8: 'salud',
  9: 'calculo',
  10: 'recetas',
  11: 'dieta',
  12: 'empezar',
  13: 'extras',
  14: 'checkout',
};

export function stepLabel(step: number): string {
  return STEP_NAMES[step] || `Paso ${step}`;
}

export function stepSlug(step: number): string {
  return STEP_SLUGS[step] || `paso_${step}`;
}

export function documentTitleForStep(step: number): string {
  if (step === 1) return 'Calculadora de comida para perros — Milo y Lola';
  return `Milo y Lola — Paso ${step}/${TOTAL_STEPS}: ${stepLabel(step)}`;
}
